var exports = {
  "Nr": "x1cb7f6e3--e1ec02--card",
  "jf": "x1cb7f6e3--e1ec02--card__heading",
  "fT": "x1cb7f6e3--e1ec02--card__title",
  "xJ": "x1cb7f6e3--e1ec02--card__title-text",
  "RM": "x1cb7f6e3--e1ec02--card__title-icon",
  "XP": "x1cb7f6e3--e1ec02--card__details",
  "$m": "x1cb7f6e3--e1ec02--card__details-item",
  "ng": "x1cb7f6e3--e1ec02--card--preview",
};

module.exports = exports;
